// extracted by css-extract-rspack-plugin
export default {"Container":"phJD5"};